import React, { FC } from 'react'
import { HeadPage } from 'src/components/elements'
import NotificationList from './list/NotificationList'
import { useTranslation } from 'react-i18next'

interface INotifications {}

const Notifications: FC<INotifications> = () => {
  const { t } = useTranslation()

  return (
    <>
      <HeadPage title={t('notifications', 'Notifications')} />
      <NotificationList />
    </>
  )
}

export default Notifications
